const UPDATE_SEARCH = (state, payload) => {
  state.searchRequest = { ...state.searchRequest, ...payload };
};

export default UPDATE_SEARCH;
